import { isVendorOnly, Role, SHRole } from 'data/User';
import { getItems } from 'lib/SessionStorage';
import { BusinessUnit } from 'data/BusinessUnit';
import User from 'data/User';
import { STORAGE_KEYS } from 'constants/general';

/**
 * Determines if the user should be treated as vendor-only based on business unit context
 * @param user - The current user
 * @param businessUnit - The business unit to check role for (optional)
 * @returns boolean indicating if user should be treated as vendor-only
 */
export const isVendorOnlyByBusinessUnit = (
  user: User, 
  businessUnit?: BusinessUnit | null
): boolean => {
  // If no business unit context, use the current user's role
  if (!businessUnit?.roleId) {
    return isVendorOnly(user);
  }

  // Get role from business unit
  const roles: SHRole[] = getItems(STORAGE_KEYS.ROLES) || [];
  const businessUnitRole = roles.find((role: SHRole) => role.id === businessUnit.roleId)?.name;
  
  // Check if vendor-only based on business unit role or fallback to user role
  return businessUnitRole 
    ? businessUnitRole === Role.Vendor
    : isVendorOnly(user);
};

/**
 * Gets the business unit by ID from session storage
 * @param businessUnitId - The business unit ID to find
 * @returns BusinessUnit or null if not found
 */
export const getBusinessUnitById = (businessUnitId?: number): BusinessUnit | null => {
  if (!businessUnitId) return null;

  const businessUnits: BusinessUnit[] = getItems(STORAGE_KEYS.BUSINESS_UNITS) || [];
  return businessUnits.find(unit => unit.id === businessUnitId) || null;
};
